import React from 'react'
import { useTranslation } from 'react-i18next'

const PaymentPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          {t('payment.payment')}
        </h1>
        <div className="bg-white rounded-lg shadow-sm p-6">
          <p className="text-gray-600">{t('payment.process_payment')}</p>
        </div>
      </div>
    </div>
  )
}

export default PaymentPage
